// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e2d2d3d4","667":"000e8c84","963":"6ff6a4a6","977":"9de75a37"}[chunkId] + ".chunk.js";
};